import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 链小云调用量统计可查询的 Skill 枚举。
 *
 * 该闭集只包含 PRD 已上线的真实 Skill，不能使用 `/chatbot/skills` 动态扩展。
 */
class AgentSkill extends UltMeta {
    RELATION_CHECK = new Meta("relation-check", "上下游关联关系排查");
    SUBJECT_RISK = new Meta("subject-risk", "业务关联主体风险排查");
    INVOICE_VERIFICATION = new Meta("invoice-verification", "发票验真");
    IMAGE_TAMPER = new Meta("image-tamper", "图片PS 痕迹校验");
    REPORT_WRITING = new Meta("report-writing", "尽调报告生成");
    STATE_OWNED_IDENTITY = new Meta("state-owned-identity", "国资身份比对");
    MINE_REPORT = new Meta("mine-report", "矿产类可研报告生成");
}

/** 全局 Skill 元数据实例，字段声明顺序即筛选项展示顺序。 */
export const AGENT_SKILL = new AgentSkill();
